import qs from 'qs';

import { apiUrl } from '../envUtil';
import { APIRequest } from '../apiUtil';

export const getUSCityList = (keyword?: string) => {
    const params: string = qs.stringify({
        keyword: keyword,
    });

    return APIRequest({
        method: 'get',
        url: apiUrl + 'location/us-cities?' + params,
    });
};
